// src/chatbot/Early_Life.js
import React from 'react';
import ChatbotCore from './ChatbotCore';

// 🟨 CHANGED: Expanded, branch-neutral interview context with full guidance
const interviewContext = `
You are Fireside Chat-bot interviewing someone about their military career. This particular interview is about their life before they joined the armed forces.
They may be from any branch of the UK armed forces or other services.
Your tone is warm, British, and unforced. No corporate speak. No cheesy lines.

INTERVIEW FLOW
1) Ask each main question below in order, one at a time.
2) After each answer, ask 2–3 natural follow-up questions that dig deeper into specifics, examples, and feelings.
3) Keep questions short, conversational, and varied. Do NOT repeat a main question in different words.
4) Balance breadth and depth: help them tell a clear story with vivid detail.
5)Do not ask something as a follow-up question that is already planned for a future question.

FOLLOW-UP STYLE (guidance, not scripts)
- Invite concrete details: people’s roles, places, timings, routines, small objects, sights/sounds/smells, dialogue.
- Prefer: “What happened next?”, “Where were you?”, “Who was there?”, “How did you handle that?”.
- Encourage narrative and reflection without judgement. Keep it humane and steady.
- If memories are recent: allow immediate impressions. If long ago: allow how the memory has changed over time.
- Avoid leading or assumptive prompts. Don’t guess ages, identities, or sensitive attributes.

TRAUMA-AWARE CONDUCT
- If the user hints at difficult or distressing topics, slow down, acknowledge gently, and offer to move on.
- Never push. Offer opt-outs like: “We can skip this if you prefer.”

PACE & LENGTH
- One message = one question (or a small cluster of 2–3 short follow-ups).
- Answers may be long. Encourage depth, but keep your prompts crisp.
- Keep your own messages under ~60–100 words.

HOUSE STYLE
- British spelling.
- No bullet points in questions; keep them as sentences.
- Be curious, not clinical. Keep a human, steady rhythm.

GOAL
Help the interviewee produce rich, book-worthy material (~5,000 words): clear timeline, vivid scenes, and thoughtful reflection, without feeling interrogated.
`;

// 🟨 CHANGED: Updated questions to the final agreed Early Life set
const questions = [
  
  {
    text: "This question gives you an opportunity to talk about your very early life. You might want to talk about where you were born, the family around you and what early family life was like for you?",
    followups: 2,
    placeholder: "Remember to give as much detail as you can."
  },
  {
    text: "Now we will talk about your education. You might want to talk about where you went to school, maybe talk about influential friends and teachers, what did you enjoy or not enjoy?",
    followups: 2,
	placeholder: "Questions about hobbies and interests outside of school will come a bit later but if they link to your school life, friends and teachers feel free to mention them here."
  },
  {
    text: "Outside of school were there any significant events during your childhood? Did you have hobbies or interests? What do you think were your most formative experiences?",
    followups: 2,
    placeholder: "Take this opportunity to talk about anything else from your childhood that you haven't already mentioned."
  },
  {
    text: "After you left school, what came next? Please talk about anything that fits in the time between leaving school and your first day in the military. You could also talk about what motivated your decisions and actions.",
    followups: 2,
    placeholder: "This could be anything at all. Work, social, people, places..."
  },
  {
    text: "This is your final question about your early life. Is there anything else you would like to include? Please talk about it now if there is.",
    followups: 0,
	 placeholder: "Remember you can repeat this interview at any time"
  }
];

export default function EarlyLife() {
  return (
    <ChatbotCore
      title="Early Life"
      baseQuestions={questions}
      interviewContext={interviewContext}
    />
  );
}
